export default __webpack_public_path__ + "static/media/telegram-white.970d056b.svg";